<template>
  <div class="wrap">

    <Loading :show="loading" />

    <div class="inline-block">
      <label>Datumfält</label>
      <Dropdown
        :options="propertyValues"
        :valuebinder.sync="property"
        label="Datumvärde"
        :validated="false"
        :show-label-subtitle="false"
        @changed="fetch()"
        />
    </div>

    <div class="inline-block">
      <label>Period</label>
      <Dropdown
        prefixicon="calendar"
        prefixicon-validated="calendar-white"
        ref="dateDropdown"
        tabindex="0"
        :options="[]"
        :validated="false"
        :label="'' + formatDate(pickedStartDate) + ''"
        @clicked="datepickerRangeModal"
        :bold-label="false"
        @clicked-suffix="dateClear">
      </Dropdown>
    </div>

    <div class="inline-block">
      <label>Betalda</label>
      <button
        @click="toggledPayed(option.value)"
        v-for="option in payedYesno"
        :class="{
          button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (selectedPayed[option.value]),
          }"
        >
        {{option.title}}
      </button>
    </div>

    <div class="inline-block">
      <label>Betalmetod</label>
      <button
        @click="togglePayType(option.value)"
        v-for="option in payTypes"
        :class="{
          button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (selectedPayTypes[option.value]),
          }"
        >
        {{option.title}}
      </button>
    </div>

    <div class="inline-block">
      <label>Betalmetod mobilhyra</label>
      <button
        @click="toggleSubPayType(option.value)"
        v-for="option in subPayTypes"
        :class="{
          button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (selectedSubPayTypes[option.value]),
          }"
        >
        {{option.title}}
      </button>
    </div>

    <div class="inline-block">
      <label>Orderkälla</label>
      <button
        @click="toggleOrderSource(option.value)"
        v-for="option in orderSources"
        :class="{
          button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (selectedOrderSources[option.value]),
          }"
        >
        {{option.title}}
      </button>
    </div>

    <div class="inline-block">
      <label>Resultat</label>
      <Dropdown
        :options="perPageOptions"
        :valuebinder.sync="perPage"
        label="Per sida"
        :validated="false"
        :show-label-subtitle="false"
        @changed="fetch()"
        />
    </div>

    <div class="inline-block">
      <label>Vy</label>
      <Dropdown
        :options="groupOptions"
        :valuebinder.sync="groupBy"
        label="Vy"
        :validated="false"
        :show-label-subtitle="false"
        @changed="fetch()"
        />
    </div>

    <div class="inline-block" v-if="this.groupBy === 'line'">
      <label>Ordertyp</label>
      <button
        @click="toggleType(option.value)"
        v-for="option in types"
        v-if="SITE_CONFIG.modules[option.module]"
        :class="{
          button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (selectedTypes[option.value]),
          }"
        >
        {{option.title}}
      </button>
    </div>

    <div class="inline-block">
      <label>&nbsp;</label>
      <button @click="fetch()" class="white border"><icon name="Reset" :scale="2" /></button>
    </div>

    <div class="inline-block" v-if="showDirectSearch">
      <label>Direktsök</label>
      <input v-model="searchQuery" @keyup.enter="doSearch()" type="text" class="short" />
    </div>

    <div class="inline-block">
      <label>Gäst</label>
      <input v-model="searchQueryName" @keyup.enter="fetch()" type="text" />
    </div>

    <div style="clear:both;"></div>
    <div>
      Visar: <b>{{from}}</b>-<b>{{to}}</b> av <b>{{total}}</b>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      Sida:
      <div @click="changePage(p)" :class="'button small border ' + ((p == page) ? '' : 'white')" v-for="p in pages">{{p}}</div>
    </div>
    <div>
        <a :href="getExcelReportLink">Exportera som Excel</a>
    </div>
    <div style="clear:both;"></div>

    <table>
      <thead>
        <tr>
          <th>#</th>
          <th @click="setSortBy('created_at')" :class="{active: (sortKey == 'created_at')}">Skapad</th>
          <th v-if="groupBy === 'line'" @click="setSortBy('pretty_type')" :class="{active: (sortKey == 'pretty_type')}">Typ</th>
          <th v-if="groupBy === 'line'" @click="setSortBy('person_name')" :class="{active: (sortKey == 'person_name')}">Namn</th>
          <th @click="setSortBy('arrival')" :class="{active: (sortKey == 'arrival')}">Från</th>
          <th @click="setSortBy('departure')" :class="{active: (sortKey == 'departure')}">Till</th>
          <th @click="setSortBy('has_error')" :class="{active: (sortKey == 'has_error')}">Fel</th>
          <th @click="setSortBy('status')" :class="{active: (sortKey == 'status')}">Status</th>
          <th @click="setSortBy('line_sum')" :class="{active: (sortKey == 'line_sum')}">Summa</th>
          <th v-if="groupBy === 'head'" @click="setSortBy('line_sum_skirental')" :class="{active: (sortKey == 'line_sum_skirental')}">Hyra</th>
          <th v-if="groupBy === 'head'" @click="setSortBy('line_sum_skischool')" :class="{active: (sortKey == 'line_sum_skischool')}">Skola</th>
          <th @click="setSortBy('pretty_klarna_status')" :class="{active: (sortKey == 'pretty_klarna_status')}">Betalstatus</th>
          <th @click="setSortBy('number')" :class="{active: (sortKey == 'number')}">Ordernr.</th>
          <th @click="setSortBy('order_source')" :class="{active: (sortKey == 'order_source')}">Källa</th>
          <th @click="setSortBy('payment_method')" :class="{active: (sortKey == 'payment_method')}">Betalmetod</th>
          <th @click="setSortBy('sub_payment_method')" :class="{active: (sortKey == 'sub_payment_method')}">Hyra</th>
          <th @click="setSortBy('synced_with_r360')" :class="{active: (sortKey == 'synced_with_r360')}">Synkad <span v-if="SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'kungsberget'">360</span><span v-else>Skibar</span></th>
          <th v-if="SITE_CONFIG.site !== 'vallasen' && SITE_CONFIG.site !== 'ulricehamn'" @click="setSortBy('status_customer_set')" :class="{active: (sortKey == 'status_customer_set')}">Kund</th>
          <th v-if="SITE_CONFIG.site !== 'vallasen' && SITE_CONFIG.site !== 'ulricehamn'" @click="setSortBy('status_fully_payed')" :class="{active: (sortKey == 'status_fully_payed')}">Bet</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(order, index) in (reverse ? orderBy(data, sortKey).reverse() : orderBy(data, sortKey))" :class="{
          warning: (order.pretty_status_simple < 4),
          error: (!order.number || order.has_error || order.error_code || !order.synced_with_r360),
          active: order.active,
          dimmed: (order.pretty_status_simple < 9 && order.order_source === 'web'),
          okay: (order.pretty_status_simple >= 9),
          notpayed: (SITE_CONFIG.site !== 'vallasen' && SITE_CONFIG.site !== 'ulricehamn' && !order.status_fully_payed && order.order_source === 'web'),
          customernotset: (SITE_CONFIG.site !== 'vallasen' && SITE_CONFIG.site !== 'ulricehamn' && !order.status_customer_set && order.order_source === 'web'),
          canceled: order.canceled
          }"
          @click="openOrder(order, index)">
          <td>{{order.id}}</td>
          <td>{{order.created_at | date('short-with-time')}}</td>
          <td v-if="groupBy === 'line'">{{order.pretty_type}}</td>
          <td v-if="groupBy === 'line'">{{order.person_name}}</td>
          <td>{{order.arrival}}</td>
          <td>{{order.departure}}</td>
          <td :class="{mark: order.error_code}">{{order.error_code}}</td>
          <td :class="{mark: order.pretty_status_simple < 4}">{{order.pretty_status}}</td>
          <td>{{order.line_sum | currency({symbol: false})}}</td>
          <td v-if="groupBy === 'head'">{{order.line_sum_skirental | currency({symbol: false})}}</td>
          <td v-if="groupBy === 'head'">{{order.line_sum_skischool | currency({symbol: false})}}</td>
          <td :class="{mark: order.status === 'checkout_complete'}">{{order.pretty_klarna_status}}</td>
          <td :class="{mark: !order.number}">{{order.number}}</td>
          <td>{{order.order_source}}</td>
          <td>{{order.payment_method}}</td>
          <td>{{order.sub_payment_method}}</td>
          <td>{{order.synced_with_r360 ? 'Ja' : 'NEJ'}}</td>
          <td v-if="SITE_CONFIG.site !== 'vallasen' && SITE_CONFIG.site !== 'ulricehamn'">{{order.status_customer_set ? 'Ja' : (order.source === 'web' ? 'NEJ' : '-')}}</td>
          <td v-if="SITE_CONFIG.site !== 'vallasen' && SITE_CONFIG.site !== 'ulricehamn'">{{order.status_fully_payed ? 'Ja' : (order.source === 'web' ? 'NEJ' : '-')}}</td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th v-if="groupBy === 'line'"></th>
          <th v-if="groupBy === 'line'"></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>{{sum | currency}}</th>
          <th v-if="groupBy === 'head'">{{sumSkirental | currency}}</th>
          <th v-if="groupBy === 'head'">{{sumSkischool | currency}}</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
    </table>

    <div style="clear:both;"></div>
    <div>
      Sida:
      <div @click="changePage(p)" :class="'button small border ' + ((p == page) ? '' : 'white')" v-for="p in pages">{{p}}</div>
    </div>
    <div style="clear:both;"></div>

    <router-view :key="$route.params.orderId"></router-view>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';

import Dropdown from '@/components/components/Dropdown';
import Datepicker from '@/components/components/Datepicker';

import Loading from '@/components/components/Loading';

import moment from 'moment';

export default {
  components: {
    Dropdown,
    Datepicker,
    Loading,
  },
  data() {
    return {
      data: [],
      pickedStartDate: null,
      pickedEndDate: null,
      validStartDates: [],
      property: 'created_at',
      order: 'DESC',
      currentIndex: -1,

      excel_url: '',

      pages: [],
      page: 1,
      count: 0,
      total: 0,
      from: 0,
      to: 0,

      searchQuery: '',

      perPage: '50',
      perPageOptions: [{
        title: '5',
        value: '5',
      }, {
        title: '50',
        value: '50',
      }, {
        title: '100',
        value: '100',
      }, {
        title: '500',
        value: '500',
      }, {
        title: '1000',
        value: '1000',
      }],

      sortKey: 'created_at',
      reverse: true,
      search: '',

      loading: false,

      selectedTypes: {},

      selectedPayed: {},
      selectedPayTypes: {},
      selectedSubPayTypes: {},
      selectedOrderSources: {},

      propertyValues: [{
        title: 'Skapad',
        value: 'created_at',
      }, {
        title: 'Ankomst',
        value: 'arrival',
      }, {
        title: 'Avresa',
        value: 'departure',
      }],

      showDirectSearch: false,

      groupBy: 'head',
      groupOptions: [{
        title: 'Huvud',
        value: 'head',
      }, {
        title: 'Rad',
        value: 'line',
      }],

      types: [{
        title: 'Utrustn.',
        value: 'equipment',
        module: 'skiletting',
      }, {
        title: 'Utrustn. tillv.',
        value: 'equipment_addon',
        module: 'skiletting',
      }, {
        title: 'Skidskola',
        value: 'skischool',
        module: 'school',
      }, {
        title: 'Liftkort',
        value: 'skipass',
        module: 'skipass',
      }, {
        title: 'Oladdat',
        value: 'product',
        module: 'skiletting',
      }, {
        title: 'Keycard',
        value: 'skipass_keycard',
        module: 'skipass',
      }, {
        title: 'Boende',
        value: 'accomodation',
        module: 'accomodation',
      }, {
        title: 'Bo. tillv.',
        value: 'accomodation_addon',
        module: 'accomodation',
      }, {
        title: 'Bo. liftkort',
        value: 'accomodation_skipass',
        module: 'skipass',
      }],

      payedYesno: [{
        title: 'Ja',
        value: 'yes',
      }, {
        title: 'Nej',
        value: 'no',
      }],

      payTypes: [{
        title: 'Collector',
        value: 'collector',
      }, {
        title: 'Kort på plats',
        value: 'chip',
      }, {
        title: 'Kontant',
        value: 'onsite',
      }, {
        title: 'Klarna',
        value: 'klarna',
      }],

      subPayTypes: [{
        title: 'Swish',
        value: 'swish',
      }, {
        title: 'Kort',
        value: 'card',
      }, {
        title: 'Kod',
        value: 'code',
      }, {
        title: 'Annat',
        value: 'other',
      }],

      orderSources: [{
        title: 'Web',
        value: 'web',
      }, {
        title: 'On site',
        value: 'onsite',
      }, {
        title: 'Mobilhyra',
        value: 'mobile',
      }],

      meta: {},
    };
  },
  async mounted() {
    this.getFromUrl();

    this.validStartDates = [];

    // const now = moment();
    // const currentYear = now.format('YYYY');
    // let startYear = currentYear;
    // let endYear = currentYear;
    //
    // if (parseInt(now.format('M'), 10) <= 7) {
    //   startYear = now.subtract(1, 'year').format('YYYY');
    // } else {
    //   endYear = now.add(1, 'year').format('YYYY');
    // }

    const loopStart = moment().subtract(1, 'year').toDate();
    let current = loopStart;
    const end = moment().add(1, 'year').toDate();
    let next = null;

    if (!this.pickedStartDate) {
      this.pickedStartDate = moment().toDate();
    }
    if (!this.pickedEndDate) {
      this.pickedEndDate = moment().toDate();
    }

    while (current < end) {
      next = moment(current).add(1, 'days');
      this.validStartDates.push(next.format('YYYY-MM-DD'));
      current = next.toDate();
    }

    this.fetch();

    if (localStorage.getItem('admin_show_direct_search')) {
      this.showDirectSearch = true;
    }
  },
  computed: {
    sum() {
      return this.meta.sum;
    },
    sumSkischool() {
      return this.meta.sumSkischool;
    },
    sumSkirental() {
      return this.meta.sumSkirental;
    },
    getExcelReportLink() {
      const auth = API.authSimpleParameter;
      const reportUrl = API.getUrl(`${this.excel_url}&page=1&pp=10000&report=excel&auth-simple=${auth}`);
      return reportUrl;
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    changePage(page) {
      this.page = page;
      this.updateUrl();
      this.fetch();
    },
    getFromUrl() {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      this.pickedStartDate = moment(query.pickedStartDate) || null;
      this.pickedEndDate = moment(query.pickedEndDate) || null;
      this.property = query.property || '';
      this.order = query.order || '';
      this.groupBy = query.groupBy || '';
      this.page = query.page || '';
      this.perPage = query.pp || '';

      if (!this.pickedStartDate.isValid()) {
        this.pickedStartDate = null;
      }

      if (!this.pickedEndDate.isValid()) {
        this.pickedEndDate = null;
      }

      const selectedTypes = (query.selectedTypes || '').split(',');
      const $this = this;
      selectedTypes.forEach((value) => {
        $this.toggleType(value);
      });

      const selectedPayed = (query.selectedPayed || '').split(',');
      selectedPayed.forEach((value) => {
        $this.toggledPayed(value);
      });

      const selectedPayTypes = (query.selectedPayTypes || '').split(',');
      selectedPayTypes.forEach((value) => {
        $this.togglePayType(value);
      });

      const selectedSubPayTypes = (query.selectedSubPayTypes || '').split(',');
      selectedSubPayTypes.forEach((value) => {
        $this.toggleSubPayType(value);
      });

      const selectedOrderSources = (query.selectedOrderSources || '').split(',');
      selectedOrderSources.forEach((value) => {
        $this.toggleOrderSource(value);
      });
    },
    updateUrl() {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query.pickedStartDate = moment(this.pickedStartDate).format('YYYY-MM-DD') || '';
      query.pickedEndDate = moment(this.pickedEndDate).format('YYYY-MM-DD') || '';
      query.property = this.property || '';
      query.order = this.order || '';
      query.groupBy = this.groupBy || '';
      query.selectedTypes = Object.keys(this.selectedTypes).join(',') || '';
      query.selectedPayed = Object.keys(this.selectedPayed).join(',') || '';
      query.selectedPayTypes = Object.keys(this.selectedPayTypes).join(',') || '';
      query.selectedOrderSources = Object.keys(this.selectedOrderSources).join(',') || '';
      query.page = this.page;
      query.pp = this.perPage;

      this.$router.push({
        name: this.$route.name,
        query,
      });
    },
    async fetch() {
      this.updateUrl();
      this.loading = true;
      const start = moment(this.pickedStartDate).format('YYYY-MM-DD');
      const end = moment(this.pickedEndDate).format('YYYY-MM-DD');
      const types = Object.keys(this.selectedTypes).join(',');
      const payed = Object.keys(this.selectedPayed).join(',');
      const payedTypes = Object.keys(this.selectedPayTypes).join(',');
      const subPayedTypes = Object.keys(this.selectedSubPayTypes).join(',');
      const orderSources = Object.keys(this.selectedOrderSources).join(',');
      const queryName = this.searchQueryName || '';

      let url = `/stats/orders?start=${start}&end=${end}&property=${this.property}&order=${this.order}&view=${this.groupBy}&types=${types}&page=${this.page}&pp=${this.perPage}`;
      url = `${url}&payed=${payed}&payed_types=${payedTypes}&sub_payed_types=${subPayedTypes}&order_sources=${orderSources}&name=${queryName}`;
      this.excel_url = url;

      const { data, meta } = await API.get(url);
      this.pages = meta.pagesArray;
      this.total = meta.total;
      this.count = meta.count;
      this.from = meta.from;
      this.to = meta.to;
      this.data = data;
      this.loading = false;

      this.meta = meta;
    },
    setSortBy(sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    selectDates(start, end) {
      if (!start) {
        return;
      }
      this.pickedStartDate = start;
      this.pickedEndDate = end;
      if (!end) {
        this.pickedEndDate = start;
      }
      this.fetch();
    },
    formatDate() {
      const start = moment(this.pickedStartDate).format('D/M');
      const end = moment(this.pickedEndDate).format('D/M');
      return `${start} - ${end}`;
    },
    datepickerRangeModal() {
      this.openModal(['DatepickerRangeModal', {
        clickOutside: false,
        validDates: this.validStartDates,
        pickedStartDate: this.pickedStartDate,
        pickedEndDate: this.pickedEndDate,
        onClose: this.selectDates,
        onPickStart: this.setEndDates,
        night: [],
        allowPrevious: true,
        terminology: 'Välj',
        info: 'Välj datum',
        infoOnPicked: 'Välj slutdatum',
        showAllMonths: true,
      }]);
    },
    dateClear() {
      this.pickedStartDate = null;
      this.pickedEndDate = null;
    },
    setEndDates() {
      const promise = new Promise((resolve) => {
        resolve(365);
      });
      return promise;
    },
    openOrder(order) {
      // if (this.currentIndex > -1 && this.data[this.currentIndex]) {
      //   this.$set(this.data[this.currentIndex], 'active', false);
      // }
      // this.$set(order, 'active', true);
      // this.currentIndex = index;
      this.$router.push({
        name: 'admin-stats-orders-detail',
        params: {
          orderId: order.id,
        },
      });
    },
    toggleType(value) {
      if (this.selectedTypes[value]) {
        this.$delete(this.selectedTypes, value);
      } else {
        this.$set(this.selectedTypes, value, true);
      }
      this.fetch();
    },
    toggledPayed(value) {
      if (this.selectedPayed[value]) {
        this.$delete(this.selectedPayed, value);
      } else {
        this.$set(this.selectedPayed, value, true);
      }
      this.fetch();
    },
    togglePayType(value) {
      if (this.selectedPayTypes[value]) {
        this.$delete(this.selectedPayTypes, value);
      } else {
        this.$set(this.selectedPayTypes, value, true);
      }
      this.fetch();
    },
    toggleSubPayType(value) {
      if (this.selectedSubPayTypes[value]) {
        this.$delete(this.selectedSubPayTypes, value);
      } else {
        this.$set(this.selectedSubPayTypes, value, true);
      }
      this.fetch();
    },
    toggleOrderSource(value) {
      if (this.selectedOrderSources[value]) {
        this.$delete(this.selectedOrderSources, value);
      } else {
        this.$set(this.selectedOrderSources, value, true);
      }
      this.fetch();
    },
    async doSearch() {
      const { data } = await API.get(`/order/search?q=${this.searchQuery}`);
      this.openOrder(data);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

input
  input()
  width 200px !important
  min-width 200px !important
  max-width 200px !important
  &.short
    width 100px !important
    min-width 100px !important
    max-width 100px !important

.wrap
  width 98%
  margin-left 1%

table
  width 100%
th, td
  text-align left
  padding 6px 5px
  white-space: nowrap;
  //border-bottom 1px solid #eeeeee
  cursor pointer
table tbody tr
  &:hover
    opacity 0.8
  /*&.active
    opacity 0.6*/
  &.dimmed
    opacity 0.3
  &.okay
    background-color lightgreen
  &.warning
    background-color: lightyellow
  &.error
    background-color: pink
  &.notpayed
    background-color lightyellow
  &.customernotset
    background-color orange
    border 3px dashed red
    &.dimmed
      border 0
  &.canceled
    background-color: lightgrey
td.mark
  font-weight: bold
tr:nth-child(2n)
  background-color #f7f7f7

.flex
  display flex

.inline-block
  display inline-block
  float left
  margin-right 10px
</style>



// WEBPACK FOOTER //
// OrderList.vue?415a243b